import { render, staticRenderFns } from "./pubtalent.vue?vue&type=template&id=6c525914&scoped=true"
import script from "./pubtalent.vue?vue&type=script&lang=js"
export * from "./pubtalent.vue?vue&type=script&lang=js"
import style0 from "./pubtalent.vue?vue&type=style&index=0&id=6c525914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c525914",
  null
  
)

export default component.exports